import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import ErrorFallback from '@/components/ErrorFallback';
import Spinner from '@/components/Spinner';
import AuthProvider from '@/context/auth/AuthProvider';
import env from '@/utils/constants';

const queryClient = new QueryClient();

function AppProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <React.Suspense
      fallback={
        <div className="grid place-items-center w-screen h-screen">
          <Spinner size="xl" />
        </div>
      }>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {env.VITE_APP_VERSION === 'local' && (
              <ReactQueryDevtools />
            )}
            <AuthProvider>{children}</AuthProvider>
            <Toaster position="bottom-right" />
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
}

export default AppProvider;
